import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyDoYTuM2057BMgB7Bz08XYR8ndHpkQUj-8",
  authDomain: "social-network-57380.firebaseapp.com",
  projectId: "social-network-57380",
  storageBucket: "social-network-57380.appspot.com",
  messagingSenderId: "190674711093",
  appId: "1:190674711093:web:5ac9f1366953452218377c",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

const auth = firebase.auth();
const storage = firebase.storage();

const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider, storage };
export default db;
